import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Checkbox,
    Paper,
    Chip,
    Grid,
} from '@mui/material';
import { cores } from '../theme';
import { CalendarMonth, CheckCircle, Event, RadioButtonUnchecked, CheckCircleOutline } from '@mui/icons-material';

const ControleDeFrequencia = ({ presencasSalvas, onChange }) => {
    const [presencas, setPresencas] = useState(
        presencasSalvas || {
            aula_1: [false, false, false, false],
            aula_2: [false, false, false, false],
        }
    );

    const [totais, setTotais] = useState({
        total_aulas: 8,
        aulas_presente: 0,
        percentual: 0
    });

    useEffect(() => {
        if (presencasSalvas) {
            if (!presencasSalvas.aula_1 && !presencasSalvas.aula_2) {
                setPresencas({
                    aula_1: [false, false, false, false],
                    aula_2: [false, false, false, false],
                });
            } else {
                setPresencas(presencasSalvas);
            }

            calculaTotais(presencasSalvas);
        }
    }, [presencasSalvas]);

    const calculaTotais = (presencasObj) => {
        const aulasPresente =
            (presencasObj.aula_1 || []).filter(p => p).length +
            (presencasObj.aula_2 || []).filter(p => p).length;

        const novosTotais = {
            total_aulas: 8,
            aulas_presente: aulasPresente,
            percentual: (aulasPresente / 8) * 100
        };

        setTotais(novosTotais);
        return novosTotais;
    };

    const lidarComMudancaCheckbox = (keyAula, indexCheck) => {
        const novoEstadoPresencas = { ...presencas };
        const checksDaAula = [...novoEstadoPresencas[keyAula]];

        checksDaAula[indexCheck] = !checksDaAula[indexCheck];
        novoEstadoPresencas[keyAula] = checksDaAula;

        setPresencas(novoEstadoPresencas);

        const novosTotais = calculaTotais(novoEstadoPresencas);

        onChange({
            presencas: novoEstadoPresencas,
            total_aulas: novosTotais.total_aulas,
            aulas_presente: novosTotais.aulas_presente,
            percentual: novosTotais.percentual
        });
    };

    return (
        <Box>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 3
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CalendarMonth sx={{ color: cores.secundaria.principal }} />
                    <Typography variant="subtitle1" fontWeight="600" color={cores.secundaria.principal}>
                        Registro de Presença
                    </Typography>
                </Box>
                <Chip
                    label={`${totais.aulas_presente}/${totais.total_aulas} aulas (${Math.round(totais.percentual || 0)}%)`}
                    color={totais.percentual >= 75 ? "success" : "warning"}
                    variant="outlined"
                    icon={<CheckCircle />}
                    sx={{ fontWeight: 600 }}
                />
            </Box>

            <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                gap: 3,
                mb: 2
            }}>
                {/* Card para a Aula 1 */}
                <Paper
                    elevation={0}
                    sx={{
                        flex: 1,
                        borderRadius: 2,
                        border: `1px solid ${cores.cinza.claro}`,
                        overflow: 'hidden',
                        transition: 'box-shadow 0.2s ease',
                        '&:hover': {
                            boxShadow: cores.sombras.medio
                        }
                    }}
                >
                    <Box
                        sx={{
                            bgcolor: cores.cinza.clarissimo,
                            p: 1.5,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: `1px solid ${cores.cinza.claro}`
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Event sx={{ color: cores.secundaria.principal, fontSize: '1.2rem' }} />
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    color: cores.cinza.escuro
                                }}
                            >
                                Aula 1
                            </Typography>
                        </Box>
                        <Chip
                            size="small"
                            label={`${presencas.aula_1.filter(p => p).length}/4`}
                            color={presencas.aula_1.filter(p => p).length >= 3 ? "success" : presencas.aula_1.filter(p => p).length > 0 ? "warning" : "error"}
                            sx={{ height: 24, fontWeight: 600 }}
                        />
                    </Box>

                    <Box sx={{ p: 2 }}>
                        <Grid container spacing={1}>
                            {[...Array(4)].map((_, index) => {
                                const presente = presencas.aula_1[index];

                                return (
                                    <Grid item xs={12} sm={6} key={index}>
                                        <Box
                                            onClick={() => lidarComMudancaCheckbox('aula_1', index)}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                p: 1,
                                                borderRadius: 1,
                                                bgcolor: presente ? `rgba(${parseInt(cores.sucesso.principal.slice(1, 3), 16)}, ${parseInt(cores.sucesso.principal.slice(3, 5), 16)}, ${parseInt(cores.sucesso.principal.slice(5, 7), 16)}, 0.08)` : 'transparent',
                                                border: presente ? `1px solid rgba(${parseInt(cores.sucesso.principal.slice(1, 3), 16)}, ${parseInt(cores.sucesso.principal.slice(3, 5), 16)}, ${parseInt(cores.sucesso.principal.slice(5, 7), 16)}, 0.2)` : '1px solid rgba(0, 0, 0, 0.12)',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                '&:hover': {
                                                    bgcolor: presente ? `rgba(${parseInt(cores.sucesso.principal.slice(1, 3), 16)}, ${parseInt(cores.sucesso.principal.slice(3, 5), 16)}, ${parseInt(cores.sucesso.principal.slice(5, 7), 16)}, 0.12)` : 'rgba(0, 0, 0, 0.04)',
                                                }
                                            }}
                                        >
                                            <Checkbox
                                                checked={presente}
                                                icon={<RadioButtonUnchecked />}
                                                checkedIcon={<CheckCircleOutline />}
                                                sx={{
                                                    padding: 0.5,
                                                    mr: 1,
                                                    color: cores.cinza.medio,
                                                    '&.Mui-checked': {
                                                        color: cores.sucesso.principal,
                                                    }
                                                }}
                                            />
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontWeight: presente ? 600 : 400,
                                                    color: presente ? cores.secundaria.principal : cores.cinza.escuro
                                                }}
                                            >
                                                Presença {index + 1}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Box>
                </Paper>

                {/* Card para a Aula 2 */}
                <Paper
                    elevation={0}
                    sx={{
                        flex: 1,
                        borderRadius: 2,
                        border: `1px solid ${cores.cinza.claro}`,
                        overflow: 'hidden',
                        transition: 'box-shadow 0.2s ease',
                        '&:hover': {
                            boxShadow: cores.sombras.medio
                        }
                    }}
                >
                    <Box
                        sx={{
                            bgcolor: cores.cinza.clarissimo,
                            p: 1.5,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: `1px solid ${cores.cinza.claro}`
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Event sx={{ color: cores.secundaria.principal, fontSize: '1.2rem' }} />
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    color: cores.cinza.escuro
                                }}
                            >
                                Aula 2
                            </Typography>
                        </Box>
                        <Chip
                            size="small"
                            label={`${presencas.aula_2.filter(p => p).length}/4`}
                            color={presencas.aula_2.filter(p => p).length >= 3 ? "success" : presencas.aula_2.filter(p => p).length > 0 ? "warning" : "error"}
                            sx={{ height: 24, fontWeight: 600 }}
                        />
                    </Box>

                    <Box sx={{ p: 2 }}>
                        <Grid container spacing={1}>
                            {[...Array(4)].map((_, index) => {
                                const presente = presencas.aula_2[index];

                                return (
                                    <Grid item xs={12} sm={6} key={index}>
                                        <Box
                                            onClick={() => lidarComMudancaCheckbox('aula_2', index)}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                p: 1,
                                                borderRadius: 1,
                                                bgcolor: presente ? `rgba(${parseInt(cores.sucesso.principal.slice(1, 3), 16)}, ${parseInt(cores.sucesso.principal.slice(3, 5), 16)}, ${parseInt(cores.sucesso.principal.slice(5, 7), 16)}, 0.08)` : 'transparent',
                                                border: presente ? `1px solid rgba(${parseInt(cores.sucesso.principal.slice(1, 3), 16)}, ${parseInt(cores.sucesso.principal.slice(3, 5), 16)}, ${parseInt(cores.sucesso.principal.slice(5, 7), 16)}, 0.2)` : '1px solid rgba(0, 0, 0, 0.12)',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                '&:hover': {
                                                    bgcolor: presente ? `rgba(${parseInt(cores.sucesso.principal.slice(1, 3), 16)}, ${parseInt(cores.sucesso.principal.slice(3, 5), 16)}, ${parseInt(cores.sucesso.principal.slice(5, 7), 16)}, 0.12)` : 'rgba(0, 0, 0, 0.04)',
                                                }
                                            }}
                                        >
                                            <Checkbox
                                                checked={presente}
                                                icon={<RadioButtonUnchecked />}
                                                checkedIcon={<CheckCircleOutline />}
                                                sx={{
                                                    padding: 0.5,
                                                    mr: 1,
                                                    color: cores.cinza.medio,
                                                    '&.Mui-checked': {
                                                        color: cores.sucesso.principal,
                                                    }
                                                }}
                                            />
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontWeight: presente ? 600 : 400,
                                                    color: presente ? cores.secundaria.principal : cores.cinza.escuro
                                                }}
                                            >
                                                Presença {index + 1}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Box>
                </Paper>
            </Box>
        </Box>
    );
};

export default ControleDeFrequencia;